import PropTypes from 'prop-types';
import { Component } from 'react';
import { displayAds } from 'src/client/displayAds';
import { mintSingleton } from 'src/client/mint';
import { player } from 'src/client/player';
import { storeSingleton } from 'src/client/store/storeSingleton';
import { selectIsNowPlayingDialogOpen } from 'src/common/selectors/dialog';
import { isCategory } from '../../utils/guideItemTypes';
import isServer from '../../utils/isServer';

function getMatchUrl(props) {
  return props.routeProps?.matchUrl ?? props.match?.url;
}

function buildDisplayAdsPageTargeting(props, screenName) {
  const pageTargeting = { screen: screenName };
  const guideId = props.routeProps?.guideContext?.guideId;

  pageTargeting.categoryId = isCategory(guideId) ? guideId : null;

  return pageTargeting;
}

export default function withAdScreenRequest(getScreenName) {
  return (BaseComponent) => {
    class WithScreenAdRequest extends Component {
      static propTypes = {
        match: PropTypes.object.isRequired,
        routeProps: PropTypes.shape({
          matchUrl: PropTypes.string,
        }),
      };

      constructor(props) {
        super(props);
        if (!isServer()) {
          this.updateCurrentScreen();
        }
      }

      async updateCurrentScreen({ refreshDisplayAds = false } = {}) {
        const isNowPlayingDialogOpen = selectIsNowPlayingDialogOpen(storeSingleton.state);
        const screenName = isNowPlayingDialogOpen ? 'nowPlaying' : getScreenName(this.props);

        await displayAds.setPageTargeting(buildDisplayAdsPageTargeting(this.props, screenName));
        mintSingleton.updateState('currentScreen', screenName);
        player.setAppSessionData({ currentScreen: screenName });

        if (refreshDisplayAds && displayAds.isReady) {
          await displayAds.refresh();
        }
      }

      componentDidUpdate(prevProps) {
        const prevMatchUrl = getMatchUrl(prevProps);
        const matchUrl = getMatchUrl(this.props);
        const routeChanged = prevMatchUrl !== matchUrl;
        const paramsChanged = prevProps.match?.params !== this.props.match?.params;

        if (routeChanged || paramsChanged) {
          void this.updateCurrentScreen({ refreshDisplayAds: routeChanged });
        }
      }

      render() {
        return <BaseComponent {...this.props} />;
      }
    }

    return WithScreenAdRequest;
  };
}
